import MaterialTable from '@material-table/core';
import Spinner from 'components/Spinner';
import { formatAmount } from 'Helper';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import useSWR from 'swr';

// const tabs = ['Weekly prizes', 'Monthly prizes', 'All prizes'];


const Participation = () => {
    // const [activeTab, setActiveTab] = useState('Weekly');
    const [searchParam] = useSearchParams()
    const id = searchParam.get('game')
    const { data, isValidating } = useSWR(`/promos/give-aways/stats/${id}/participations`)

    const columns = [
        // { title: 'Give away', field: 'give_away', id: 'customer_name' },
        // { title: 'Reference', field: 'reference', id: 'amount' },
        { title: 'Username', field: 'username', id: 'net_amount' },
        { title: 'Email', field: 'email', id: 'payment_mode' },
        { title: 'Phone', field: 'phone', id: 'amount' },
        { title: 'Points', field: 'total_points', id: 'net_amount' },
        { title: 'Amount', field: 'total_amount', render: data => formatAmount(data?.total_amount), id: 'payment_mode' },
        { title: 'Last Transaction', field: 'last_transaction_on', id: 'net_amount' },
        { title: 'Date', field: 'date', id: 'payment_mode' },
    ]

    // const data = [
    //     {
    //         id: 3,
    //         give_away: 'Weekly Prize',
    //         reference: 'REF12345',
    //         username: 'TheGoat',
    //         email: 'stonecodersoft@gmail.com',
    //         phone: '+24174868097',
    //         points: 1204,
    //         amount: 120400,
    //         date: '2025-06-29 11:45:12'
    //     }
    // ];

    return (
        <div className=" mx-auto bg-white rounded-2xl p-4">
            {/* Tabs */}
            {/* <div className="flex gap-2 mb-4">
                {tabs.map((tab) => (
                    <button
                        key={tab}
                        onClick={() => setActiveTab(tab)}
                        className={`px-4 py-1.5 text-sm rounded-[16px] border transition-colors
                                  ${activeTab === tab
                                ? 'bg-white border-primary text-primary font-medium'
                                : 'bg-white border-gray-200 text-dark'
                            }`}
                    >
                        {tab}
                    </button>
                ))}
            </div> */}


            {/* Participation list */}
            <div className="w-full">
                <MaterialTable

                    columns={columns}

                    actions={[
                        {
                            icon: 'save',
                            tooltip: 'Save User',
                        },
                    ]}
                    localization={{
                        header: {
                            actions: "",
                        },
                        body: {
                            emptyDataSourceMessage: isValidating ? <Spinner /> : 'No transactions to display',

                        }
                    }}
                    //   onRowClick={(_,data)=>{
                    //     dispatch(previewModal({
                    //       title: `${t('transaction.preview_title')}`,
                    //       content: () => <PreviewTransaction tableProps={data} />
                    //     }))
                    //   }}
                    options={{
                        rowStyle: {
                            // cursor: 'pointer',
                            height: '100px',
                            color: "#05213D"
                        },
                        actionsColumnIndex: -1,
                        headerStyle: {
                            // color: "#05213D",
                            fontWeight: 700,
                            fontFamily: 'Helvetica Neue',
                            lineHeight: '21px',
                            fontSize: '16px',

                        },
                        actionsCellStyle: { width: '10px' },
                        search: false,
                        toolbar: false,
                        pageSize: 10,
                        emptyRowsWhenPaging: false,

                        // pageSizeOptions: [5, 10, 15, 20, 25, 30],
                        // paging: true
                    }}

                    data={
                        data?.data
                    }
                    components={{
                        Action: () => null,



                        // Pagination: ({ data }) => (<TablePaginationDemo {...misc} />)
                    }}
                />
            </div>
        </div>
    );
};

export default Participation;
